// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-banking-gate-overlay {
  position: fixed;
  z-index: 1400;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--overlay-default, rgba(10, 22, 20, 0.44));
}

.invoice-banking-gate-overlay--checking {
  background: transparent;
  cursor: wait;
}

.invoice-banking-gate-modal {
  box-sizing: border-box;
  display: flex;
  width: min(520px, 100%);
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  padding: 0;
  overflow: hidden;
  color: var(--text-primary, #142624);
  background: var(--surface-elevated, #fff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-xl, 20px);
  box-shadow: 0 6px 8px rgba(14, 26, 32, 0.1), 0 1px 1px rgba(14, 26, 32, 0.04);
  font-family: "Lexend", sans-serif;
}

.invoice-banking-gate-modal header {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  padding: 28px 28px 20px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  box-sizing: border-box;
}

.invoice-banking-gate-modal header > svg {
  width: 24px;
  height: 24px;
  color: var(--interactive-default, #0f766e);
}

.invoice-banking-gate-modal h2 {
  flex: 1 1;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0;
}

.invoice-banking-gate-copy {
  padding: 24px 28px 0;
}

.invoice-banking-gate-modal p {
  width: 100%;
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
}

.invoice-banking-gate-close {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}

.invoice-banking-gate-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  justify-content: flex-end;
  padding: 28px;
}

.invoice-banking-gate-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md, 10px);
  font-family: "Lexend", sans-serif;
  font-weight: 500;
  cursor: pointer;
}

.invoice-banking-gate-secondary {
  height: 40px;
  padding: 0 12px;
  color: var(--text-primary, #142624);
  background: var(--surface-primary, #fff);
  border: 1px solid var(--border-default, #cdd6d4);
  font-size: 13px;
}

.invoice-banking-gate-primary {
  height: 44px;
  padding: 0 16px;
  color: var(--on-interactive-primary, #fff);
  background: var(--interactive-default, #0f766e);
  border: 1px solid var(--interactive-default, #0f766e);
  font-size: 14px;
}

.invoice-banking-gate-actions button:focus-visible {
  outline: 3px solid rgba(15, 118, 110, 0.25);
  outline-offset: 2px;
}

@media (max-width: 1023px) {
  .invoice-banking-gate-overlay {
    left: 0;
  }
}

@media (max-width: 520px) {
  .invoice-banking-gate-modal {
    min-height: 0;
    padding: 24px;
  }

  .invoice-banking-gate-actions {
    width: 100%;
    flex-direction: column-reverse;
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Invoices/invoiceCreationGate.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;EACzC,+CAA+C;EAC/C,qCAAqC;EACrC,6EAA6E;EAC7E,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,wCAAwC;EACxC,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,+CAA+C;EAC/C,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,oBAAoB;EACtB;AACF","sourcesContent":[".invoice-banking-gate-overlay {\n  position: fixed;\n  z-index: 1400;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: var(--overlay-default, rgba(10, 22, 20, 0.44));\n}\n\n.invoice-banking-gate-overlay--checking {\n  background: transparent;\n  cursor: wait;\n}\n\n.invoice-banking-gate-modal {\n  box-sizing: border-box;\n  display: flex;\n  width: min(520px, 100%);\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n  padding: 0;\n  overflow: hidden;\n  color: var(--text-primary, #142624);\n  background: var(--surface-elevated, #fff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-xl, 20px);\n  box-shadow: 0 6px 8px rgba(14, 26, 32, 0.1), 0 1px 1px rgba(14, 26, 32, 0.04);\n  font-family: \"Lexend\", sans-serif;\n}\n\n.invoice-banking-gate-modal header {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 12px;\n  padding: 28px 28px 20px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  box-sizing: border-box;\n}\n\n.invoice-banking-gate-modal header > svg {\n  width: 24px;\n  height: 24px;\n  color: var(--interactive-default, #0f766e);\n}\n\n.invoice-banking-gate-modal h2 {\n  flex: 1;\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 26px;\n  letter-spacing: 0;\n}\n\n.invoice-banking-gate-copy {\n  padding: 24px 28px 0;\n}\n\n.invoice-banking-gate-modal p {\n  width: 100%;\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n}\n\n.invoice-banking-gate-close {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n\n.invoice-banking-gate-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  justify-content: flex-end;\n  padding: 28px;\n}\n\n.invoice-banking-gate-actions button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md, 10px);\n  font-family: \"Lexend\", sans-serif;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.invoice-banking-gate-secondary {\n  height: 40px;\n  padding: 0 12px;\n  color: var(--text-primary, #142624);\n  background: var(--surface-primary, #fff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  font-size: 13px;\n}\n\n.invoice-banking-gate-primary {\n  height: 44px;\n  padding: 0 16px;\n  color: var(--on-interactive-primary, #fff);\n  background: var(--interactive-default, #0f766e);\n  border: 1px solid var(--interactive-default, #0f766e);\n  font-size: 14px;\n}\n\n.invoice-banking-gate-actions button:focus-visible {\n  outline: 3px solid rgba(15, 118, 110, 0.25);\n  outline-offset: 2px;\n}\n\n@media (max-width: 1023px) {\n  .invoice-banking-gate-overlay {\n    left: 0;\n  }\n}\n\n@media (max-width: 520px) {\n  .invoice-banking-gate-modal {\n    min-height: 0;\n    padding: 24px;\n  }\n\n  .invoice-banking-gate-actions {\n    width: 100%;\n    flex-direction: column-reverse;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
